import { useState, useEffect } from "react";
import logo from "../images/logo1.png";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-red-950 via-blue-950 to-blue-900 text-white">
      {/* CTA Banner */}
      <div className="bg-gradient-to-r from-red-900 to-blue-900 py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '2.5rem' }}
            className="mb-3">
            READY TO FIND YOUR DREAM PROPERTY?
          </h3>
          <p className="text-red-100 mb-8 max-w-lg mx-auto" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Let's talk about your land or commercial space requirements. Our experts are ready to help you.
          </p>
          <a href="#contact"
            className="inline-flex items-center gap-2 bg-white text-red-700 font-bold px-10 py-4 rounded-xl
            hover:bg-red-50 transition-all duration-300 shadow-xl">
            Enquire Now
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3"/>
            </svg>
          </a>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand - Using imported logo */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img 
                src={logo} 
                alt="NexEdge Infra Logo" 
                className="w-[120px] h-[80px] object-contain"
              />
            </div>
            <p className="text-blue-300/60 text-sm leading-relaxed mb-6" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Trusted real estate developer in Dehradun specializing in quality plotting projects and commercial spaces since 2020.
            </p>
            <div className="flex gap-3">
              {[
                { name: "instagram", icon: <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>, url: "https://www.instagram.com/nexedgeinfra" },
                { name: "youtube", icon: <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>, url: "https://www.youtube.com/@nexedgeinfra" },
                { name: "website", icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.66 0 3-4 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4-3-9s1.34-9 3-9"/>, url: "https://nexedgeinfra.com" }
              ].map(s => (
                <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-red-900 hover:bg-gradient-to-br hover:from-red-900 hover:to-blue-900 flex items-center justify-center transition-all duration-300 text-blue-300 hover:text-white">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    {s.icon}
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Services - Updated for plotting/commercial */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm tracking-widest uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1rem' }}>
              Our Services
            </h4>
            <ul className="space-y-3">
              {["Residential Plots","Commercial Spaces","Retail Shops","Land Investment","Property Consultation","Legal Documentation"].map(s => (
                <li key={s}>
                  <a href="#services" className="text-blue-300/60 hover:text-red-300 text-sm transition-colors duration-200"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}>
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm tracking-widest uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1rem' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {["About Us","Our Projects","Testimonials","Contact Us","Privacy Policy","Terms of Service"].map(l => (
                <li key={l}>
                  <a href={`#${l.toLowerCase().replace(/\s+/g, '')}`} className="text-blue-300/60 hover:text-red-300 text-sm transition-colors duration-200"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}>
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact - Updated with Dehradun address */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm tracking-widest uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1rem' }}>
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="text-blue-300/60 text-sm flex items-start gap-2" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                <span className="text-red-400 mt-0.5">📍</span>
                <span>Khasra No. 759/B, Upper Tunwala, Pushp Vihar, Chaktonwala Grant, Dehradun, Uttarakhand – 248005</span>
              </li>
              <li className="text-blue-300/60 text-sm flex items-center gap-2">
                <span className="text-red-400">📞</span>
                +91 96674 04020
              </li>
              <li className="text-blue-300/60 text-sm flex items-center gap-2">
                <span className="text-red-400">✉️</span>
                nexedgeinfra@gmail.com
              </li>
              <li className="text-blue-300/60 text-sm flex items-center gap-2">
                <span className="text-red-400">🕒</span>
                Mon-Sat: 10AM-7PM | Sun: 11AM-4PM
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-8 border-t border-red-900/50 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-blue-400/50 text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            © 2026 NexEdge Infra. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-blue-400/50 hover:text-red-400 text-sm transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" className="text-blue-400/50 hover:text-red-400 text-sm transition-colors duration-200">
              Terms of Service
            </a>
            <a href="#" className="text-blue-400/50 hover:text-red-400 text-sm transition-colors duration-200">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}